module.exports = __webpack_public_path__ + "static/img/cstSer_bg_05.14e88f8a.svg";